// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgWifiOff = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.598c-2.233 0-3.926.825-5.457 1.893a.6.6 0 0 1-.687-.985C3.5 3.36 5.432 2.398 8 2.398c.584 0 1.138.05 1.664.142a.6.6 0 1 1-.205 1.182 8.496 8.496 0 0 0-1.46-.124Zm5.424-1.024a.6.6 0 0 1 0 .849l-.38.38c.382.221.747.458 1.099.703a.6.6 0 0 1-.687.985 13.522 13.522 0 0 0-1.294-.807L10.717 6.13c.496.202.963.458 1.396.76a.6.6 0 1 1-.686.984 5.976 5.976 0 0 0-1.647-.806L8.048 8.799c.86.01 1.657.292 2.305.765a.6.6 0 0 1-.707.97A2.785 2.785 0 0 0 8 9.998c-.617 0-1.185.199-1.647.536a.596.596 0 0 1-.098.058l-2.031 2.03a.6.6 0 0 1-.849-.848l9.2-9.2a.6.6 0 0 1 .849 0Zm-6.16 3.638a.6.6 0 0 1-.468.707 5.966 5.966 0 0 0-2.223.954.6.6 0 0 1-.686-.985 7.165 7.165 0 0 1 2.67-1.145.6.6 0 0 1 .707.469ZM8 12.998a.2.2 0 1 0 0-.4.2.2 0 0 0 0 .4Zm-1-.2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
    />
  </svg>
)

export default SvgWifiOff
